import React from 'react'
import { Grid, Typography, Paper, Box } from '@mui/material'
import DataBlockCounter from '../../../../../components/StarlinkAdmin/ServiceLines/DataBlockCounter';
interface Props {
  dataAmount: number
  price: number
  quantity: number
  currency: string
  selected: boolean
  onSelect: () => void
  onQuantityChange: (value: number) => void
}

const TopUpTierCardNew: React.FC<Props> = ({
  dataAmount,
  price,
  selected,
  currency,
  quantity,
  onSelect,
  onQuantityChange
}) => {
  const isDisabled = !dataAmount || price === undefined;

  const handleClick = () => {
    if (!isDisabled && onSelect) {
      onSelect();
    }
  };
  return (
    <>
    <Paper
      elevation={0}
      onClick={handleClick}
      className={`topup-tier-card ${selected ? 'selected' : ''}`}
    >
      {selected && <div className="dpo-topup-checkmark">✓</div>}

      <Grid container direction="column" alignItems="center" spacing={1}>
        <Grid item>
          <Typography variant="h6" fontWeight={700}>
            +{dataAmount} GB
          </Typography>
        </Grid>

        <Grid item>
          <Typography color="primary" fontWeight={600}>
            {currency || ''} {price || 0}
          </Typography>
        </Grid>
      </Grid>
    </Paper>

    {selected && (
        <Box mt={1} display="flex" justifyContent="center">
          <DataBlockCounter
            value={quantity}
            min={1}
            onChange={onQuantityChange}
          />
        </Box>
      )}
</>
  )
}

export default TopUpTierCardNew